import { ApiErrorDisplay } from '@core/ApiErrorDisplay';
import { AxiosErrorResponse } from '@core/error.models';
import { CircularProgressBar, Tooltip } from '@gcl/react-core';
import * as React from 'react';
import './FileUploadWithDisplay.scss';

export interface IFileUploadLoaderProps {
  error: AxiosErrorResponse | null;
  uploadProgress: number | undefined;
  fileName?: string;
  render: () => React.ReactElement;
}

export const FileUploadLoader: React.FC<IFileUploadLoaderProps> = ({
  error,
  uploadProgress,
  render,
  fileName = 'File',
}) => {
  return (
    <>
      <ApiErrorDisplay
        errors={[
          {
            error,
            genericError: `Upload file failed`,
          },
        ]}
      />
      {uploadProgress === undefined || uploadProgress === 100 || !!error ? (
        render()
      ) : (
        <>
          <Tooltip overlay={`${fileName} uploading`}>
            <CircularProgressBar
              value={uploadProgress || 0}
              className="gcl-gems-upload-with-display-upload-progress-bar"
            />
          </Tooltip>
        </>
      )}
    </>
  );
};
